
import { UTILITIES } from 'helpers/utils';
import { loadCustomerEmail, PriceFileRequest } from 'helpers/api';
import M from 'materialize-css';

const state = {
    manufacturers: [],
    customerEmail: '',
    customerAccount: ''
};

const AppContainerId = '#price_file';

document.addEventListener('DOMContentLoaded', async () => {
    M.AutoInit();
    const appContainer = document.querySelector(AppContainerId);
    if (!appContainer) return;

    await loadManufacturers();
    await DefaultCustomerEmail();

    renderForm(appContainer);
});

async function loadManufacturers() {
    const res = await fetch('/assets/json/manufacturers/price_file_request.json');
    state.manufacturers = await res.json();
}

async function DefaultCustomerEmail() {

    const email = await loadCustomerEmail();

    state.customerEmail = email.data.customerEmail || '';

    state.customerAccount = email.data.customerAccount || '';

    const emailInput = document.querySelector('#recipient_email');

    if (emailInput) {
        emailInput.value = state.customerEmail;
    }
}

function renderForm(container) {
    const form = document.createElement('form');
    form.className = 'email-request-form';
    form.style.maxWidth = '1200px';
    form.style.width = '100%';
    form.style.padding = '20px';

    // Heading + line
    const heading = document.createElement('h5');
    heading.textContent = 'Select Each Manufacturer List';
    heading.style.marginBottom = '10px';
    heading.style.fontSize = '1.50rem';

    const hr = document.createElement('hr');
    hr.style.border = 'none';
    hr.style.borderTop = '1px solid #ccc';
    hr.style.margin = '0 0 20px 0';

    // Two-column grid container (custom, not Materialize columns)
    const manufacturerRow = document.createElement('div');
    manufacturerRow.className = 'manufacturer-row';

    state.manufacturers.forEach((m, index) => {
        const checkboxId = `mfg_${index}`;

        const col = document.createElement('div');
        col.className = 'col';

        const descHtml = m.description && m.description.trim()
            ? ` <span class="manufacturer-desc">(${m.description})</span>`
            : '';

        col.innerHTML = `
      <label for="${checkboxId}" style="display:flex; align-items:center; gap:10px; cursor:pointer; width:100%;">
        <input type="checkbox" id="${checkboxId}" value="${m.code} - ${m.name} (${m.description || ''})" class="filled-in" />
        <span style="display:flex; align-items:center; gap:10px; font-size:1rem;">
          <img src="${m.logo}" alt="${m.name}" class="manufacturer-logo">
          <span class="manufacturer-name">${m.code} - ${m.name}</span>${descHtml}
        </span>
      </label>
    `;

        manufacturerRow.appendChild(col);
    });

    // Email field
    const emailField = document.createElement('div');
    emailField.className = 'input-field';
    emailField.style.marginTop = '70px';
    emailField.style.marginBottom = '10px';
    emailField.innerHTML = `
    <input type="email" id="recipient_email" value="${state.customerEmail || ''}" />
    <label for="recipient_email" class="active">Your Email Address (optional override)</label>
  `;

    // Centered, nicer button (uses Materialize classes if present)
    const buttonWrapper = document.createElement('div');
    buttonWrapper.className = 'btn-primary-center';

    const sendButton = document.createElement('button');
    sendButton.id = 'send_email_btn';
    sendButton.type = 'button';
    sendButton.className = 'btn waves-effect waves-light blue';
    sendButton.innerHTML = `
    <i class="material-icons" style="font-size:20px;">send</i>
    <span>Send Email</span>
  `;
    sendButton.addEventListener('click', onSendEmail);

    buttonWrapper.appendChild(sendButton);

    // Assemble
    container.innerHTML = '';
    form.appendChild(heading);
    form.appendChild(hr);
    form.appendChild(manufacturerRow);
    form.appendChild(emailField);
    form.appendChild(buttonWrapper);
    container.appendChild(form);

    // If email loaded after render for any reason, set it here too
    const emailInput = document.querySelector('#recipient_email');
    if (emailInput && state.customerEmail) {
        emailInput.value = state.customerEmail;
    }
}


async function onSendEmail() {

    const selectedManufacturers = Array.from(
        document.querySelectorAll('#price_file .manufacturer-row input[type="checkbox"]:checked')
    ).map(i => i.value);

    const recipientEmail = document.querySelector('#recipient_email').value.trim();

    if (!recipientEmail || selectedManufacturers.length === 0) {
        M.toast({ html: 'Please select manufacturers and provide an email.' });
        return;
    }

    const postData = {
        customerEmail: recipientEmail,
        customerAccount: state.customerAccount,
        manufacturers: selectedManufacturers
    };

    console.log('postData', postData);

    try {

        var status = await PriceFileRequest(postData);

        if (!status) {
            M.toast({ html: 'Failed to send email. Please try again later.' });
            return;
        }

        M.toast({ html: 'Request received successfully. You should receive price files within 48 hours.' });

        document
            .querySelectorAll('#price_file .manufacturer-row input[type="checkbox"]')
            .forEach(cb => cb.checked = false);

        document.querySelector('#recipient_email').value = state.customerEmail || '';

        const sendButton = document.getElementById('send_email_btn');
        if (sendButton) {
            const successMsg = document.createElement('div');
            successMsg.innerHTML = `
        <i class="material-icons" style="vertical-align: middle; margin-right: 8px; color: green;">check_circle</i>
        Request received successfully. You should receive price files within 48 hours.
    `;
            successMsg.style.display = 'flex';
            successMsg.style.alignItems = 'center';
            successMsg.style.justifyContent = 'center';
            successMsg.style.fontWeight = 'bold';
            successMsg.style.color = 'white';
            successMsg.style.backgroundColor = 'black';
            successMsg.style.padding = '10px';
            successMsg.style.marginTop = '15px';
            successMsg.style.borderRadius = '5px';
            successMsg.style.textAlign = 'center';
            successMsg.style.fontSize = '1rem';

            sendButton.replaceWith(successMsg);
        }


    } catch (error) {
        M.toast({ html: 'Failed to send email. Please try again later.' });
    }
}



// WEBPACK FOOTER //
// ./app/js/modules/price-file-request.js